import { render, staticRenderFns } from "./priorities-select.vue?vue&type=template&id=4969a4fb&"
import script from "./priorities-select.vue?vue&type=script&lang=js&"
export * from "./priorities-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports